module.exports = "./img/d9f38a4fca02112d47bbed11ed08fe3d.jpg";